module.exports = __webpack_public_path__ + "static/media/logo_macizo1.8c4ed8d5.png";